import status from "../../constants/actionStatus";

const getSolutionReducer = (
    state = {
        solution: {},
    },
    action = {}
) => {
    switch (action.type) {
    case "SOLUTION_REQUEST":
        return {
            status: status.PENDING,
            solution: {},
        };
    case "SOLUTION_SUCCESS":
        return {
            status: status.SUCCESS,
            solution: action.payload,
        };

    case "SOLUTION_FAILURE":
        return {
            status: status.ERROR,
            solution: {},
        };
    default:
        return state;
    }
};

export default getSolutionReducer;
